const QuestionTypeVersion = {
    Classical: 0,
    RoundedDynamic: 1
};
export default QuestionTypeVersion;
